module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/style-loader.js!./~/weex-vue-loader/lib/style-rewriter.js?id=data-v-f0650c94!./packages/dof-catalog/colmo.css
// module id = 551
// module chunks = 0 1